/**
 * Created by Ning Jiang on 2021-05-27.
 */

import {ReelStopPresentationController} from "../ReelStopPresentationController";
import {IReelStateEventData} from "../../../core/reel/ReelState";
import {SerialSound} from "../../sound/SerialSound";
import {Serial} from "../../Serial";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";

export class ReelStopSoundController extends ReelStopPresentationController {

    public spinStates:boolean[][];
    public stopSoundPlayed:boolean[][];

    constructor() {
        super('ReelStopSoundController');
        this.spinStates = [
            [false, false, false, false, false, false, false],
            [false, false, false, false, false, false, false],
            [false, false, false, false, false, false, false],
            [false, false, false, false, false, false, false],
            [false, false, false, false, false, false, false]
        ];
    }

    protected onReelBounce(data:IReelStateEventData):Promise<any> {
        if(!this.stopSoundPlayed[data.reelId][0]) {
            this.stopSoundPlayed[data.reelId][0] = true;
            SerialSound.soundPlayer.playTrack({
                name : Serial.model.parsedGameData.mode.includes(GameMode.FREESPIN) ?
                    SerialSound.REELS_LANDING_FS :
                    SerialSound.REELS_LANDING
            });
        }
        return super.onReelBounce(data);
    }

    protected onReelStopped(data:IReelStateEventData):Promise<void> {
        this.spinStates[data.reelId][3] = false;
        this.tryStopSpinSound();

        return super.onReelStopped(data);
    }

    protected onEnhancerReelBounce(data:IReelStateEventData):Promise<any> {
        if(Serial.enhancerReels[data.reelId][data.positionId].isOpened && !this.stopSoundPlayed[data.reelId][1]) {
            this.stopSoundPlayed[data.reelId][1] = true;
            SerialSound.soundPlayer.playTrack({name : SerialSound.REELS_LANDING_ENHANCER});
        }
        return super.onEnhancerReelBounce(data);
    }

    protected onEnhancerReelStopped(data:IReelStateEventData):Promise<any> {
        this.spinStates[data.reelId][data.positionId] = false;
        this.tryStopSpinSound();

        return super.onEnhancerReelStopped(data);
    }

    private tryStopSpinSound():void {
        if(this.spinStates.every(r => {
            return r.every(s => !s);
        })) {
            SerialSound.PLAYING_LOOP_EFFECT = "";
            SerialSound.soundPlayer.stopTrack(SerialSound.REELS_SPINNING);
            SerialSound.soundPlayer.stopTrack(SerialSound.REELS_SPINNING_FS);
        }
    }

    protected reset() {
        super.reset();
        this.stopSoundPlayed = [
            //middle reel, enhancers
            [false, false],
            [false, false],
            [false, false],
            [false, false],
            [false, false]
        ];
    }
}